module.exports = __webpack_public_path__ + "static/img/bg1.a902c36b.jpg";